import MatchTable from '@/components/dashboard/matchs/matchTable';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/dashboard/matchs')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <section className="w-[80%] flex flex-grow flex-col gap-4 ">
      <MatchTable />
    </section>
  );
}
